/**
 * Identifies the OIDC configuration registered in `authConfigFactory`.
 * Used wherever an IdP must be referenced by name (login, session check, etc.)
 * to prevent typo-prone raw string literals.
 */
export enum IdpConfigId {
  Oidc = 'oidc',
  Okta = 'okta',
}
